import { Pages } from 'modules/navigation/domain/enums/pages';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useLingui } from '@lingui/react/macro';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMatch } from 'react-router-dom';

import { AppDispatch } from 'store/store';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import { fetchBoardsByTemplateId, fetchUserTemplates } from 'modules/template-editor/store/templates/actions';
import { setActiveBoard, setActiveTemplate, setTournamentId } from 'modules/template-editor/store/templates/templates';
import useTemplates from './use-templates';

export function useLoadTemplates() {
  const { t } = useLingui();
  const dispatch = useDispatch<AppDispatch>();
  const dispatchWithToast = useDispatchWithToast();
  const { templateId } = useMatch(Pages.TEMPLATE.BOARDS + '/*')?.params ?? {};
  const { boardId } = useMatch(Pages.TEMPLATE.EDITOR + '/*')?.params ?? {};

  const { info } = useOrganizer();
  const { isLoaded: isTemplatesLoaded, tournamentId, loadedTemplates } = useTemplates();
  const isAdmin = useIsAdmin();

  useEffect(() => {
    if (!info) return;
    if (isTemplatesLoaded && info.id === tournamentId) return;
    dispatch(setTournamentId({ id: info.id }));
    dispatchWithToast(fetchUserTemplates({ ownerId: info.id, visibility: isAdmin ? ['superAdmin', 'all'] : ['all'] }), {
      error: t`Не удалось загрузить шаблоны`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, info, isTemplatesLoaded, isAdmin, templateId]);

  useEffect(() => {
    if (templateId && !loadedTemplates.includes(Number(templateId))) {
      dispatchWithToast(fetchBoardsByTemplateId({ templateId: Number(templateId) }), { error: t`Не удалось загрузить табло` });
    }
  }, [dispatchWithToast, templateId, loadedTemplates, t]);

  useEffect(() => {
    if (templateId) {
      dispatch(setActiveTemplate({ id: parseInt(templateId) }));
    }

    if (boardId) {
      dispatch(setActiveBoard({ id: parseInt(boardId) }));
    }
  }, [boardId, dispatch, templateId]);
}
